import { colors } from '../../Colors/colors'

export const selfServeLeadTemplate = {
   light: {
      common: {
         closeIconBGColor: colors['gray-500'],
         sections: {
            plusIconFillColor: colors['primary-600'],
            addSectionButtonBGColor: '!bg-transparent',
            sectionCard: {
               sectionNameTextColor: 'text-gray-600',
               sectionCardBGColor: 'bg-white',
               countTextColor: 'text-gray-700',
               selectedBorderColor: 'border-primary-600'
            },
            defaultSection: {
               iconFillColor: colors['gray-700'],
               menuBGColor: 'hover:bg-gray-50',
               dotsMoveIconFillColor: colors['gray-500']
            },
            deletedSection: {
               trashIconColor: colors['gray-500'],
               flipBackwardIconColor: colors['gray-500']
            },
            sectionPopoverMenu: {
               editIconFillColor: colors['gray-500'],
               deleteIconFillColor: colors['error-600'],
               editButtonTextColor: 'text-gray-900',
               deleteButtonTextColor: 'text-error-600'
            }
         },
         fields: {
            sectionHeader: {
               sectionName: 'text-gray-900',
               sectionDescription: 'text-gray-700'
            },
            createCustomField: {
               titleText: 'text-gray-900',
               descriptionText: 'text-gray-600',
               fieldTypeOption: 'text-gray-700 ',
               selectedIconColor: colors['primary-600'],
               separationLineColor: 'bg-gray-300',
               searchIconColor: colors['gray-500'],
               corePropertiesTitle: 'text-gray-900',
               corePropertiesFooterBorder: 'border-gray-300',
               morePropertiesNavTex: 'text-gray-800',
               morePropertiesNavIcon: colors['gray-500'],
               backIcon: colors['gray-500']
            }
         },
         errorMessages: {
            userIsNotAdministrator: {
               containerBGColor: 'bg-gray-100',
               titleColor: 'text-gray-900',
               descriptionColor: 'text-gray-600'
            }
         }
      },

      leadTemplate: {
         body: {
            bodyBGColor: 'bg-gray-100'
         },
         fields: {},
         header: {
            headerBGColor: 'bg-white',
            borderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900'
         },
         collapsibleSection: {
            chevronIconColor: colors['gray-500'],
            sectionTextColor: 'text-gray-600',
            lineBGColor: 'bg-gray-300'
         }
      },
      deleteSection: {
         deleteSectionNameTextColor: 'text-gray-700',
         deleteSectionNameBorderColor: 'border-gray-300'
      },

      createOrUpdateSection: {
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         fieldLabelTextColor: 'text-gray-700'
      },
      restoreSection: {
         prefixIconBGColor: 'bg-primary-100',
         prefixIconBorderColor: 'border-primary-50',
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         flipBackwardIconBGColor: colors['primary-600'],
         restoreSectionNameTextColor: 'text-gray-700',
         restoreSectionNameBorderColor: 'border-gray-300'
      },
      customSectionFieldTable: {
         headerColumnStyles: 'text-gray-500',
         cellLabelStyles: 'text-gray-800',
         cellDataStyles: 'text-gray-600',
         editIconColor: colors['gray-500'],
         menuTriggerIconColor: colors['gray-700'],
         menuTriggerHoverColor: 'hover:bg-gray-50',
         menuOptions: {
            optionTextColor: 'text-gray-900',
            hoverBgColor: 'hover:bg-gray-50',
            borderColor: 'border-gray-200',
            iconColor: colors['gray-700'],
            editIconFillColor: colors['gray-500'],
            deleteIconFillColor: colors['error-600'],
            editButtonTextColor: 'text-gray-900',
            deleteButtonTextColor: 'text-error-600',
            moveButtonIconFillColor: colors['gray-500'],
            moveButtonTextColor: 'text-gray-900'
         },
         fieldTypeIconColor: colors['gray-500']
      },
      fieldOptions: {
         addOptionsTextColor: 'text-gray-900',
         optionsErrorTextColor: 'text-error-600'
      },
      moveField: {
         sectionNameTextColor: 'text-gary-700',
         sectionCardBGColor: 'bg-primary-50',
         sectionCardBorderColor: '!border-primary-600',
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         closeIconColor: colors['gray-500']
      },
      deleteField: {
         deleteFieldNameTextColor: 'text-gray-700',
         deleteFieldNameBorderColor: 'border-gray-300'
      },
      configurations: {
         titleColors: 'text-gray-900',
         descriptionColors: 'text-gray-700',
         cardBgColor: 'bg-white'
      }
   },

   dark: {}
}
